module.exports = __webpack_public_path__ + "img/top-min.9764ae32.png";